import { render } from "./Vue3IconPicker.vue?vue&type=template&id=3adc3b30&scoped=true"
import script from "./Vue3IconPicker.vue?vue&type=script&lang=js"
export * from "./Vue3IconPicker.vue?vue&type=script&lang=js"

import "./Vue3IconPicker.vue?vue&type=style&index=0&id=3adc3b30&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adc3b30"]])

export default __exports__